<template>
	<div class="form-row" :class="{ split: split, right: right, left: left }">
		<slot />
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
export default defineComponent({
	name: "I2FormRow",
	components: {},
	props: {
		split: {
			type: Boolean,
		},
		right: {
			type: Boolean,
		},
		left: {
			type: Boolean,
		},
	},
})
</script>

<style scoped>
.form-row {
	display: flex;
	align-items: flex-end;
	gap: 1rem;
	width: 100%;
	margin-bottom: 1rem; /* Consistent spacing between rows */
}

/* Remove margin from the last form row to avoid extra space at bottom */
.form-row:last-child {
	margin-bottom: 0;
}

/* Ensure child fields take equal space and align properly */
.form-row > * {
	flex: 1;
	min-height: 80px; /* Match I2FormField min-height */
}
</style>
